import { useViewerStore } from "../state/viewerStore";

export function PerfHUD() {
  const showHud = useViewerStore((s) => s.showHud);
  const toggleHud = useViewerStore((s) => s.toggleHud);
  const fps = useViewerStore((s) => s.fps);
  const drawn = useViewerStore((s) => s.drawnSplats);
  const total = useViewerStore((s) => s.totalSplats);
  const quality = useViewerStore((s) => s.quality);

  if (!showHud) {
    return (
      <button className="hud-toggle" onClick={toggleHud} aria-label="show HUD">
        ▾
      </button>
    );
  }

  const fpsColor = fps >= 50 ? "#7ee787" : fps >= 28 ? "#ffd166" : "#f47373";

  return (
    <div className="perf-hud">
      <div className="row">
        <span className="label">FPS</span>
        <span className="value" style={{ color: fpsColor }}>{fps}</span>
      </div>
      <div className="row">
        <span className="label">Splats</span>
        <span className="value">{(drawn / 1_000).toFixed(0)}k / {(total / 1_000).toFixed(0)}k</span>
      </div>
      <div className="row">
        <span className="label">Quality</span>
        <span className="value">{quality}</span>
      </div>
      <button className="hud-toggle hud-toggle-inline" onClick={toggleHud} aria-label="hide HUD">×</button>
    </div>
  );
}
